<div>
  <div
    bsModal
    #childModal="bs-modal"
    class="modal fade custom-modal"
    tabindex="-1"
    role="dialog"
    [config]="{ backdrop: true }">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <span>Choose the target group</span>
          <img src="assets/img/x.svg" (click)="cancel()" alt="" />
        </div>
        <div class="modal-body" style="text-align: center">
          <ul class="options">
            <li *ngFor="let g of groups">
              <label class="radio">
                <input type="radio" [formControl]="chosen" [value]="g" name="target-group" />
                <span class="radio-label">{{ g.name }}</span>
              </label>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <div style="margin-right: 0">
            <button class="btn btn-cancel" (click)="cancel()">Cancel</button>
          </div>
          <div style="margin-left: 0">
            <button class="btn btn-save" (click)="ok()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
